import { RSAA } from 'redux-api-middleware'
import {
  getApiPath,
  makeQueryParams,
  webStorage,
} from 'sidecar-utility-library'

import { types, initialState } from 'store/MemberCommunication'
import { memberTestFlag } from './utils'

/**
 * Fetches the number of unresolved requests based on the member, account or
 * expense id, value used for the tab counter
 *
 * @param {string} project 'MEMBER', Future development could incorporate PROD
 *   SUPPORT
 * @param {string} ticketType 'Member Care Issue Tracking' Future development
 *   could incorporate PROD SUPPORT
 * @param {boolean} test DEV & QA = false
 */
export const fetchUnresolvedMessages = () => {
  const project = ['MEMBER']
  const ticketType = ['Member Care Issue Tracking']
  // Get the member UUIDs from accountMemberAccessMap so that tickets
  // are only fetched for the members who the logged in user has access to.
  const phiUuidList =
    JSON.parse(webStorage.getItem('accountMemberAccessMap'))?.PHI || []

  const requestPayload = {
    project,
    ticketType,
    // Maps to the Jira mcom_control form field:
    // - DEV & QA environments: false
    // - PROD environment: empty string
    test: memberTestFlag === 'test',
    memberUuid: phiUuidList,
  }

  return {
    [RSAA]: {
      endpoint: getApiPath(
        `comm`,
        `jira/member/totals${makeQueryParams(requestPayload)}`,
      ),
      method: 'GET',
      types: [
        types.FETCH_UNRESOLVED_MESSAGES_REQUEST,
        types.FETCH_UNRESOLVED_MESSAGES_SUCCESS,
        types.FETCH_UNRESOLVED_MESSAGES_ERROR,
      ],
    },
  }
}

export const clearUnresolvedMessages = () => ({
  type: types.CLEAR_UNRESOLVED_MESSAGES,
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_UNRESOLVED_MESSAGES_REQUEST:
      return {
        ...state,
        unresolved: {
          busy: true,
          error: null,
        },
      }

    case types.FETCH_UNRESOLVED_MESSAGES_SUCCESS:
      return {
        ...state,
        unresolved: {
          entity: payload,
          busy: false,
          error: null,
        },
      }

    case types.FETCH_UNRESOLVED_MESSAGES_ERROR:
      return {
        ...state,
        unresolved: {
          busy: false,
          error: payload,
        },
      }

    case types.CLEAR_UNRESOLVED_MESSAGES:
      return {
        ...state,
        unresolved: {
          entity: {},
          busy: false,
          error: null,
        },
      }

    default:
      return state
  }
}
